export const LEAD_PACKAGE_TITLE = 'Landing page + WhatsApp chatbot setup';

export const LEAD_PACKAGE_CHATBOT_SERVICE_NOTE =
  'The monthly chatbot service fee covers ongoing chatbot service only — not website hosting, domain, or e-commerce platform fees. Message us for a scoped quote.';
